import React  , { Component } from 'react'

import {  HomeSlider,
          HomeDeals,
          ConcertSliderItem,
          HomeTitle         } from '../../Components/UI/UI'

import {  showsArr } from "../../Data/Data";
import { compareDates, getWeather } from "../../Utility/Utility";

import Menu from '../../Components/Menu/Menu'
import Footer from '../../Components/Footer/Footer'

import "../innerPage.css"
import "./LiveShows.css"

class LiveShows extends Component {

  state = {
   
    telAvivWeather : 0,
    waterTemp : 0,
    jerusalemWeather : 0,

  }

  componentDidMount () {

    getWeather((Weather)=>{
      
      console.log("Weather", Weather);
      this.setState({
        telAvivWeather : Weather.telAvivWeather,
        waterTemp : Weather.water_temp,
        jerusalemWeather : Weather.jerusalemWeather,
      })

      
    });
    

     
  }

  render(){
    let counter = 0;
    let counter2 = 0;
    let hasBean = [];
    const  date1 = new Date();
    const concertSHtml = showsArr.map( (o,i) => {
        let cssClass="newAddOpacity";
        let html ="";
        if ( counter % 4 === 0 ) {
          cssClass ="first newAddOpacity";
        }

        if ( o.isDouble === true){
          cssClass ="double-singer newAddOpacity";
        }

        const isTodayBigger = compareDates(date1, o.date);
        if ( isTodayBigger === true  || o.date === "30.12.2017" || o.date === "21.06.2018") {
          cssClass +=" addOpacity ";
          hasBean.push(o);
        }else {

          counter++
          const url = "/Posts/Concerts/" + o.id ;
          if ( url === "/Posts/Concerts/undefined"){
            cssClass ="no-inner-page newAddOpacity";
          }
          // if (o.title === "UNITE WITH TOMORROWLAND")

        
            return <ConcertSliderItem
                  key={i}  
                  title={o.title}
                  desc={o.date}
                  img= {o.img}
                  link={url}
                  cssClass={cssClass}
                   />
          
          

        }

    });



    // remove unnaccery shows
    hasBean.splice(-3,hasBean.length % 4  + 1);
    // hasBean.splice(-1,1);
    // hasBean.splice(-1,1);
    const hasBeanSHtml = hasBean.map( (o,i) => {
        let cssClass="newAddOpacity";
        let html ="";
        if ( counter2 % 4 === 0 ) {
          cssClass =" ";
        }

        cssClass +=" addOpacity newAddOpacity";
        counter2++
          const url = "/Posts/Concerts/" + o.id ;
          // if (o.title === "UNITE WITH TOMORROWLAND")
          return <ConcertSliderItem
                  key={i}  
                  title={o.title}
                  desc={o.date}
                  img= {o.img}
                  link={url}
                  cssClass={cssClass} />

        

    });

    return(
      <div className="inner-page align-center page-LiveShows">
        <Menu />
        <HomeSlider waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather} />
        
        <section className="live-shows-section">
          <div className="container">
            <HomeTitle>
              LIVE SHOWS
            </HomeTitle>
            <div className="live-shows-wrapper">
              {concertSHtml}
              
              {hasBeanSHtml}
              <div className="clear"></div> 
            </div>
            <HomeDeals />
          </div>
        </section>
        <Footer />
      </div>
    )
  }

}



export default LiveShows


// WEBPACK FOOTER //
// ./src/Pages/LiveShows/LiveShows.js